import { render, staticRenderFns } from "./AvisDePrelevementModalDisplay.vue?vue&type=template&id=28f8f63b"
import script from "./AvisDePrelevementModalDisplay.vue?vue&type=script&lang=ts"
export * from "./AvisDePrelevementModalDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports